__turbopack_context__.v({
  "container": "InPageOptIn-module__PjxG-a__container",
  "contentBody": "InPageOptIn-module__PjxG-a__contentBody",
  "emailInput": "InPageOptIn-module__PjxG-a__emailInput",
  "gridContainer": "InPageOptIn-module__PjxG-a__gridContainer",
  "mobileButton": "InPageOptIn-module__PjxG-a__mobileButton",
  "optInBannerContent": "InPageOptIn-module__PjxG-a__optInBannerContent",
  "optInBannerText": "InPageOptIn-module__PjxG-a__optInBannerText",
  "privacyCaption": "InPageOptIn-module__PjxG-a__privacyCaption",
  "signUpSuccess": "InPageOptIn-module__PjxG-a__signUpSuccess",
  "wrapper": "InPageOptIn-module__PjxG-a__wrapper",
});
